import { Button } from 'antd';
import { useRef, useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';

import UploadMenu, { UploadMenuRef } from 'components/UploadMenu';

interface DocumentsToolbarUploadProps {
    mode?: 'button' | 'menu';
    fetchData: () => void;
}

export const DocumentsToolbarUpload: React.FC<DocumentsToolbarUploadProps> = ({ fetchData, mode }) => {
    const uploadMenuRef = useRef<UploadMenuRef>(null);
    const [uploadMenuAnchor, setUploadMenuAnchor] = useState<null | HTMLElement>(null);

    const handleUploadMenuClick = (event: React.MouseEvent<HTMLElement>) => {
        setUploadMenuAnchor(event.currentTarget);
    };

    const handleUploadMenuClose = () => {
        setUploadMenuAnchor(null);
    };

    const handleUploadMenuComplete = () => {
        fetchData();
    };

    return (
        <>
            <Button type="primary" onClick={handleUploadMenuClick} icon={<PlusOutlined />}>
                Upload
            </Button>
            <UploadMenu
                uploadref={uploadMenuRef}
                anchorEl={uploadMenuAnchor}
                open={Boolean(uploadMenuAnchor)}
                onClose={handleUploadMenuClose}
                onComplete={handleUploadMenuComplete}
            />
        </>
    );
};
